
// An API path without a leading slash is a RELATIVE URL. The browser resolves it against
// the current page and drops the last segment, so "s2/api/tenant" reaches /s2/api/tenant
// from /dashboard but /settings/s2/api/tenant from /settings/integrations — which the host
// answers with index.html at status 200, not data.
//
// Most of this codebase was written when every screen lived at /dashboard, one segment
// deep, where that accident produced the right URL. It is not an accident worth keeping:
// any screen on a two-segment route silently loses every slash-less call it makes.
//
// Deliberately narrow: it only rewrites paths that are unmistakably ours — "s1/…", "s2/…",
// "s4/…" (the service prefixes nginx routes) or a bare "api/…". A blanket rule would also
// catch genuinely relative loads such as "./data.json" or "assets/logo.png", where
// resolving against the current page is the correct behaviour.
const API_PATH = /^(s\d+|api)\//i;

const absoluteUrl = (url) => {
  if (typeof url !== 'string') return url;          // Request / URL objects pass through
  return API_PATH.test(url) ? `/${url}` : url;
};

const originalFetch = window.fetch;

let isRefreshing = false;
window.fetch = async (...args) => {
  // Normalised here as well as in apifetch: several screens call fetch() directly, and the
  // admin dashboard and the integrations panels do it from two-segment routes.
  const [input, ...rest] = args;
  const response = await originalFetch(absoluteUrl(input), ...rest);

  if (response.status === 401) { 
    try {
      const data = await response.clone().json();
      if (data.error === 'Token has expired' && !isRefreshing) {
        isRefreshing = true;
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    } catch (err) {
      console.error('Error parsing response:', err);
    }
  }

  return response;
}

//ley create the same interceptor but instead of overriding fetch we create another function that we can call in our components to handle the token expiration logic. This way we won't interfere with the global fetch behavior and we can still handle token expiration gracefully.



export const apifetch = async (url, options = {}) => {
  const response = await originalFetch(absoluteUrl(url), options);
    if (response.status === 401) {
        try {
            const data = await response.clone().json();
            if (data.error === 'Token has expired') {
                localStorage.removeItem('token');
                window.location.href = '/login';
            }
        } catch (err) {
            console.error('Error parsing response:', err);
        }   
    }
    return response;
}
